import classNames from 'classnames';
import RCDropdown from 'rc-dropdown';
import 'rc-dropdown/assets/index.css';
import type { DropdownProps as BaseProps } from 'rc-dropdown/lib/Dropdown';
import React from 'react';
import Menu, { MenuProps } from '../menu';
import { DropdownStyles, dropdownStyles } from './dropdown.styles';

type TPlacements =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight'
  | 'top'
  | 'bottom';

type TTrigger = 'click' | 'hover' | 'contextMenu';

export interface DropdownProps extends BaseProps {
  menu?: Omit<MenuProps, 'mode'>;
  placement?: TPlacements;
  trigger?: TTrigger[];
}

/**
 * Dropdown component.
 * Inspired by https://ant.design/components/dropdown
 */
const Dropdown = (props: DropdownProps, ref?: React.Ref<unknown>) => {
  const { children, overlay, menu, overlayClassName, openClassName, ...rest } = props;

  return (
    <>
      <DropdownStyles />
      <RCDropdown
        {...rest}
        overlay={overlay ? overlay : menu ? <Menu mode="inline" {...menu} /> : <></>}
        ref={ref}
        animation="slide-up"
        overlayClassName={classNames(dropdownStyles.component, overlayClassName)}
        openClassName={classNames(dropdownStyles.componentOpen, openClassName)}
      >
        {children}
      </RCDropdown>
    </>
  );
};

export default React.forwardRef(Dropdown);
